module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAbCAYAAACEP1QvAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAH6ADAAQAAAABAAAAGwAAAACFB3M2AAAA6klEQVRIDeVVCwrDIAy1o/Rw68V6oe1I3TFc3mggHcSnThnUgFTM8+VnkxBjXGRtsnZZTIABdgkt5CBjRr/1WwvbQVg14jsjFOx6eLEzbJZeQ8oCC6gUn+K9pZS9ddXGNQMZ34cXxITLUE4iHsieK96esb3HPbOLnt4jtHjmaHXarZHa/djGX0ib1Gdl6TOYzx2Gp3ohRK8ulaz2qqSuEwL4ebC04Dg5SL02aMG2zV6h8arh5HY1GEdwJc0kBwtO5R77P0cm/iJ0sGh9eniXqvmzh0HL6b52C2J7zc6Qr/2aw4mVHB2raji9AVcoY+RF52t+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/Remote-Playb.png
// module id = LdQ4
// module chunks = 6